<template>
    <b-card body-class="p-3 email-schedule">
        <div class="d-flex title-bar-block mb-4">
            <div class="icon-block me-4">
                <button id="close-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('email_schedule') }}</span>
            </div>
        </div>

        <b-card-body class="p-0">
            <b-overlay :show="loading" rounded="sm">
                <div>
                    <b-card no-body>
                        <b-tabs card>
                            <b-tab title="Schedule" active>
                                <b-card-text>
                                    <b-form class="form-sample" @submit.stop.prevent="onSubmit">
                                        <FormBuilder key="general-form-builder"
                                            :slicedFormFields="formFields.slice(0, 6)" v-model="model">
                                        </FormBuilder>
                                        <QueryFilter ref="queryRef" v-model="model.query_fields">
                                        </QueryFilter>

                                        <SlotContainer key="scheduler-container" data-label="scheduler">
                                            <FormBuilder key="scheduler-form-builder"
                                                :slicedFormFields="formFields.slice(7)" v-model="model">
                                            </FormBuilder>
                                        </SlotContainer>

                                        <b-row>
                                            <b-col cols="12" class="mt-4 mb-2 text-center">
                                                <b-button id="create-schedule-btn" class="btn btn-info btn-fw me-2"
                                                    type="submit" v-if="
                                                        hasPermissionCreate &&
                                                        !model.id
                                                    " variant="primary" :disabled="loading ? true : false
                                                        ">{{ createLabel }}</b-button>
                                                <b-button id="update-schedule-btn" class="btn btn-info btn-fw me-2"
                                                    type="submit" v-if="
                                                        hasPermissionUpdate &&
                                                        model.id
                                                    " variant="primary" :disabled="loading ? true : false
                                                        ">{{ updateLabel }}</b-button>

                                                <b-button id="delete-schedule-btn" v-if="
                                                    model.id &&
                                                    hasPermissionDelete
                                                " @click="
                                                    deleteEmailSchedule()
                                                    " class="me-1" variant="delete-button">
                                                    {{ $translate('delete') }}
                                                </b-button>

                                                <b-button id="test-email-btn" v-if="model.id" @click="triggerEmails()"
                                                    class="me-1">
                                                    {{
                                                        $translate('test_email')
                                                    }}
                                                </b-button>

                                                <b-button variant="info" id="cancel-btn" class="btn-fw" :disabled="loading ? true : false
                                                    " @click="cancel()">{{
                                                        $cancelLabel()
                                                    }}</b-button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </b-card-text>
                            </b-tab>
                            <b-tab title="Template">
                                <b-card-text>
                                    <b-row>
                                        <b-col>
                                            <b-form-select v-model="variable_email_template_id"
                                                :options="emailTemplates" value-field="id" text-field="title">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        Select Existing Template
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="8">
                                            <TipTap ref="templateEditor" v-model="model.template_data"
                                                :key="serialKey" />
                                            <b-button @click="onSubmit">Update</b-button>
                                        </b-col>
                                        <b-col>
                                            <b-row>
                                                <b-col cols="12" v-for="item in mailMergeData" :key="item + 'mailmerge'"
                                                    @click="addItemToTemplate(item)" class="clickable-item">
                                                    {{ item }}
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </b-overlay>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'
import cmMixins from './cmMixins'

import QueryFilter from './QueryFilter.vue'

import TipTap from '@/components/TipTap/Index.vue'
import FormBuilder from './FormBuilder.vue'
import SlotContainer from './SlotContainer.vue'

const default_model = {
    id: 0,
    name: null,
    email_subject: null,
    email_from_name: null,
    description: null,
    next_date: null,
    day_of_week: null,
    time_of_day: null,
    category: null,
    query_fields: null,
    termination_date: null,
    frequency: null,
    email_template_id: null,
    is_active: false,
    report_type: null,
}

export default {
    name: 'CommunicationsManagement-viewItem',
    components: { TipTap, QueryFilter, FormBuilder, SlotContainer },
    mixins: [popupMixins, permissionsMixins, errorHandlingMixins, cmMixins],
    data() {
        return {
            model: default_model,
            updating: false,
            submitting: false,
            hasErrors: false,
            serialKey: 1,
            variable_email_template_id: null
        }
    },
    props: ['item'],
    computed: {
        mailMergeData() {
            return [
                'first_name',
                'last_name',
                'email',
                'web_url',
                'subject',
                'customer.name',
                'customer.email',
                'customer.code',
                'customer.phone',
                'customer.work_number',
                'company.name',
                'company.email',
                'company.address1',
                'company.address2',
                'company.city',
                'company.country_code',
                'company.state',
                'company.zip_code',
                'company.postal',
                'company.county',
                'company.logo_url',
                'company.tagline',
                'company.phone',
            ]
        },


        scheduleItem() {
            const item = { ...this.item }
            const _item = this.$store.state.emailSchedules.item
            console.log("scheduleItem _item:", _item)
            if (_item) {
                Object.assign(item, _item);
            }
            item.is_active = !!item.is_active;
            return item;
        },

        emailTemplates() {
            return this.$store.getters["reportTemplates/emailTemplates"]
        },

        emailTemplate() {
            return this.$store.state.reportTemplates.report_template;
        },

    },

    watch: {
        scheduleItem: {
            handler: function (val) {
                if (val?.id) {
                    this.model = { ...val }
                    this.$set(this.model, 'template_data', val?.email_template?.template)
                    this.$delete(this.model, 'template')
                } else {
                    this.model = { ...default_model }
                }
                this.variable_email_template_id = this.model.email_template_id ?? null;
            },
            deep: true,
            immediate: true,
        },
        variable_email_template_id: function (id) {
            this.updating = true;
            id && this.$store.dispatch("reportTemplates/fetchById", id).then(() => {
                this.updating = false;
            })
        },
        emailTemplate: {
            handler: function (_template) {
                console.log("bingo-----2: ", _template)
                this.$set(this.model, 'template_data', _template.template)
                this.serialKey++
            },
            deep: true
        }
    },

    mounted() {
        if (this.item?.id)
            this.$store.dispatch('emailSchedules/fetchById', this.item.id)
        else this.$store.commit('emailSchedules/set_item', null)
    },
    methods: {
        getMinStartDate() {
            return (this.item?.id) ? undefined : new Date().toISOString().split('T')[0];
        },

        addItemToTemplate(item) {
            console.log('Item clicked:', item) // Debug log

            // Check if the TipTap editor instance is available
            if (this.$refs.templateEditor?.editor) {
                // Use the TipTap command to insert the content at the current cursor position
                this.$refs.templateEditor.editor.commands.insertContent(`{{${item}}}`)
            } else {
                // Fallback to appending the item to the end if the editor reference is not available
                const currentContent = this.model.template_data || ''
                const updatedContent = `${currentContent} {{${item}}}`
                this.model.template_data = updatedContent
            }

            console.log('Updated template data:', this.model.template_data) // Log the updated data
        },


        onSubmit() {
            const data = { ...(this.model || {}) }
            console.log('onSumbit data:', data)
            data.is_active = data.is_active ? 1 : 0;


            console.log("query_fields before:", data.query_fields);

            console.log("queryRef:", this.$refs["queryRef"]);
            const queryForm = this.$refs["queryRef"].getData();
            data.query_fields = JSON.stringify(queryForm);
            console.log("query_form after:", queryForm);

            const path = data.id
                ? 'emailSchedules/update'
                : 'emailSchedules/create'
            const action = data.id
                ? this.$translate('updated')
                : this.$translate('created')
            const message = data.id
                ? this.$translate('update_alert')
                : this.$translate('create_alert')
            const callback = () =>
                this.$emit('success', action, data.name, message)
            const payload = { data, callback }

            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store.dispatch(path, payload).then(() => {
                        this.$store.dispatch('reportTemplates/fetchAll')
                    })
                }
            })
        },

        triggerEmails() {
            this.$store.dispatch('emailSchedules/triggerEmails', this.model.id)
        },

        deleteEmailSchedule() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }

            // Generate and display confirmation prompt
            const title = this.$translate('delete_email_schedule_title')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = this.$translate('unable_alert')
            const alertMsg = this.$translate('delete_alert')
            const action = null
            const cb = () => {
                this.$emit(
                    'success',
                    this.$translate('deleted'),
                    model.name,
                    alertMsg,
                    action
                )
            }
            const { id } = model
            const payload = { id, cb }
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store.dispatch('emailSchedules/delete', payload)
                }
            })
        },
    },
}
</script>
<style>
.clickable-item {
    cursor: pointer;
    padding: 5px;
    background-color: #f0f0f0;
    margin: 2px 0;
    border-radius: 4px;
}

.clickable-item:hover {
    background-color: #d0e0f0;
}
</style>
